export const OWNER = 'OWNER';
export const TEAM = 'TEAM';